import React from 'react';
import { Moon, Sun } from 'lucide-react';
import { useTheme } from '../../context/ThemeContext';
import { motion } from 'framer-motion';
export function ThemeToggle() {
  const {
    theme,
    toggleTheme
  } = useTheme();
  return <button onClick={toggleTheme} className="relative p-2 rounded-xl hover:bg-[var(--bg-secondary)] transition-colors" aria-label="Toggle theme" data-id="element-160">
      <motion.div initial={false} animate={{
      rotate: theme === 'dark' ? 180 : 0
    }} transition={{
      type: 'spring',
      stiffness: 200,
      damping: 20
    }} data-id="element-161">
        {theme === 'light' ? <Moon className="w-5 h-5 text-[var(--text-secondary)]" data-id="element-162" /> : <Sun className="w-5 h-5 text-[var(--text-secondary)]" data-id="element-163" />}
      </motion.div>
    </button>;
}